import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  forgotPassForm: FormGroup;
  confirmaPassForm: FormGroup;
  errorMsg: any;
  successMsg:any;
  password: any;
  confirmationSent: any;
  passwordChanged: any;
  validPass = false;

  constructor(private formBuilder: FormBuilder, private authService: AuthenticationService) { }
  
  ngOnInit(): void {
    this.forgotPassForm = this.formBuilder.group({
      UserName: ["", Validators.required],
    });

    this.confirmaPassForm = this.formBuilder.group({
      UserName: ["", Validators.required],
      NewPwd: ["", Validators.required],
      ConfirmationCode: ["", Validators.required],
    });
  }

  checkPassword(){
    this.password = this.confirmaPassForm.controls['NewPwd'].value;
  }

  sendConfirmationCode(){
    this.errorMsg = null;
    if (this.forgotPassForm.invalid) {
      this.errorMsg = "Faltan campos por llenar."
      return;
    }
    let formObj = this.forgotPassForm.getRawValue();

    this.authService.forgotPassword(formObj).then((res:any)=>{
      console.log(res);
      if(res.HttpStatusCode == 200){
        this.successMsg = "Código de confirmación enviado a email."
        this.confirmationSent = true;
      }else{
        this.errorMsg = "Correo electrónico no existe."
      }
      
    }, err =>{
      this.errorMsg = "Error en sistema..."
      console.log(err);
    })
  }

  checkPass(data:any){  
    console.log(data);
    this.validPass = data;
  }

  setNewPass(){
    this.errorMsg = null;
    if (this.confirmaPassForm.invalid) {
      this.errorMsg = "Faltan campos por llenar."
      return;
    }
    let formObj = this.confirmaPassForm.getRawValue();

    this.authService.confirmPassword(formObj).then(res=>{
      console.log(res);
      this.successMsg = "Contraseña actualizada."
      this.passwordChanged = true;
    }, err =>{
      this.errorMsg = true;
      console.log(err);
    })
  }
  


}
